import React from 'react';
import {toAbsoluteUrl} from '../../../../../../_metronic/_helpers';
import {Button} from "react-bootstrap";
import * as actions from '../../../_redux/receiptsActions';
import can from "../../../../_common/components/Permissions/can";

export function DownloadReceiptColumnFormatter(cellContent, intl, dispatch) {
  const buttonClassName = `btn btn-icon btn-light btn-sm mx-3 custom-action-button
                           ${(can('full', 'receipts'))
    ? ``
    : `cursor-default custom-disabled-button`}`;
  const getFileById = ({id, name}) => () => {
    dispatch(actions.downloadReceipt({id, name}));
  };
  const tooltip = intl.formatMessage({
    id: "receipts-tooltip-downloadReceipt",
    defaultMessage: "Download receipt",
  });

  return (
    <div className="font-size-sm d-flex align-items-center justify-content-center">
        <Button
        variant="outline-primary"
        className={buttonClassName}
        title={tooltip}
        onClick={getFileById({
          id: cellContent,
          name: cellContent,
        })}
        disabled={!(can('full', 'receipts'))}
      >
        <img
          src={toAbsoluteUrl('/media/svg/Download_brandColor.svg')}
          alt="download"
        />
      </Button>
    </div>
  )
}
